/* unplugin-vue-components disabled */import { render } from "./selectremote.vue?vue&type=template&id=81385e66"
import script from "./selectremote.vue?vue&type=script&lang=js"
export * from "./selectremote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__